import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstallPrompt, dismissInstallPrompt } from "@/lib/pwa";

// Floating bottom banner that appears once the browser announces install
// eligibility (or on iOS, surfaces the Add-to-Home-Screen hint since
// Safari doesn't fire beforeinstallprompt). Dismissal sticks for 14d.
export function InstallPrompt() {
  const { canPrompt, iosCandidate, prompt } = useInstallPrompt();
  if (!canPrompt && !iosCandidate) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-4 sm:w-80 z-50 rounded-lg border border-border bg-card shadow-lg p-3 flex items-start gap-3"
      role="dialog"
      aria-label="Install Cornholio"
    >
      <div className="shrink-0 mt-0.5 rounded-md bg-primary/10 text-primary p-2">
        <Download size={18} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-display uppercase tracking-tight">
          Install Cornholio
        </p>
        {canPrompt ? (
          <p className="text-xs text-muted-foreground mt-0.5">
            Adds a real home-screen icon and fullscreen score view.
          </p>
        ) : (
          <p className="text-xs text-muted-foreground mt-0.5 flex items-center gap-1 flex-wrap">
            Tap <Share size={12} className="inline" /> then “Add to Home Screen”.
          </p>
        )}
        {canPrompt && (
          <div className="mt-2 flex gap-2">
            <Button
              size="sm"
              onClick={async () => {
                await prompt();
              }}
            >
              Install
            </Button>
            <Button size="sm" variant="ghost" onClick={dismissInstallPrompt}>
              Not now
            </Button>
          </div>
        )}
      </div>
      <button
        onClick={dismissInstallPrompt}
        className="shrink-0 text-muted-foreground hover:text-foreground"
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
}
